import axiosInstance from "@/config/axios";

interface DirectorsParams {
	skip?: number;
	limit?: number;
	companyId?: string;
	year?: number;
	formTypeId?: string;
	isDirectorForm?: boolean;
	directorId?: string;
	boardId?: string;
}

export const getDirectors = async (params?: DirectorsParams) => {
	const configs = {
		params: {
			skip: params?.skip || 0,
			limit: params?.limit || 30,
			companyId: params?.companyId
				? params.companyId.replace(/^"(.+)"$/, "$1")
				: undefined,
		},
	};

	try {
		const response = await axiosInstance.get("/boards", configs);
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};
interface BoardDirectorType {
	id: string;
	name: string;
}

interface ApiResponse {
	status: boolean;
	message: string;
	data: BoardDirectorType[];
}

export const master = async () => {
	try {
		const response = await axiosInstance.get<ApiResponse>(
			"/master/board-director-types",
		);

		// Categorize and store IDs in localStorage
		const yourselfId = response.data.data.find(
			(item) => item.name === "ປະເມີນຕົວເອງ",
		)?.id;
		const boardId = response.data.data.find(
			(item) => item.name === "ຂັ້ນເທິງຖັດ",
		)?.id;
		const workplaceId = response.data.data.find(
			(item) => item.name === "ບ່ອນຢູ່ສັງກັດ",
		)?.id;
		const governmentId = response.data.data.find(
			(item) => item.name === "ເພື່ອນຮ່ວມງານປະເມີນ",
		)?.id;

		localStorage.setItem("yourself_director", yourselfId || "");
		localStorage.setItem("board_director", boardId || "");
		localStorage.setItem("workplace_director", workplaceId || "");
		localStorage.setItem("government_director", governmentId || "");

		return response.data.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};
export const getDirectorsByCompany = async (params?: DirectorsParams) => {
	try {
		const configs = {
			params: {
				skip: params?.skip || 0,
				limit: params?.limit || 30,
				formTypeId: params?.formTypeId
					? params.formTypeId.replace(/^"(.+)"$/, "$1")
					: undefined,
				isDirectorForm: false,
				boardId: params?.boardId
					? params.boardId.replace(/^"(.+)"$/, "$1")
					: undefined,
			},
		};
		console.log(configs);
		const response = await axiosInstance.get(
			"/board-directors/company",
			configs,
		);

		if (!response.data) {
			throw new Error("No data received from server");
		}

		return response.data;
	} catch (error) {
		console.error("Error in getBoardByCompany:", error);
		throw error;
	}
};
export const getQuestion = async (id: string) => {
	try {
		const response = await axiosInstance.get(`/board-directors/${id}`);

		if (!response.data) {
			throw new Error("No data received from server");
		}

		return response.data;
	} catch (error) {
		console.error("Error in getBoardByCompany:", error);
		throw error;
	}
};

interface AnswerDetail {
	question: string;
	questionId: string;
	answer: number;
	description: string | null;
}

interface AnswerTitle {
	titleAnswer: string;
	boarDirectorAnswerDetails: AnswerDetail[];
}

interface AnswerPayload {
	fromId: string;
	isDirectorForm: boolean;
	boardId: string;
	boarDirectorAnswerTitles: AnswerTitle[];
}

export const postAnswer = async (data: AnswerPayload) => {
	try {
		const response = await axiosInstance.post(
			"/board-directors/answer-in-system",
			data,
		);

		if (!response.data) {
			throw new Error("No response received from server");
		}

		return response.data;
	} catch (error) {
		console.error("Error posting answer:", error);
		throw error;
	}
};

interface FormLinkPayload {
	formId: string;
	directorId: string;
	isDirectorForm: boolean;
	boardId?: string;
}

export const postFormLink = async (data: FormLinkPayload) => {
	let thedata;

	if (data.isDirectorForm === true) {
		thedata = {
			formId: data.formId,
			directorId: data.directorId,
			isDirectorForm: data.isDirectorForm,
		};
	} else {
		thedata = {
			formId: data.formId,
			isDirectorForm: data.isDirectorForm,
			boardId: data.boardId,
		};
	}

	try {
		const response = await axiosInstance.post(
			"/board-directors/form-link",
			thedata,
		);
		if (!response.data) {
			throw new Error("No response received from server");
		}
		return response.data;
	} catch (error) {
		console.error("Error posting form link:", error);
		throw error;
	}
};
